<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            width="24"
            height="24"
            fill="white"
            fill-opacity="0.01"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5 4.5C13.5 5.32843 12.8284 6 12 6C11.1716 6 10.5 5.32843 10.5 4.5C10.5 3.67157 11.1716 3 12 3C12.8284 3 13.5 3.67157 13.5 4.5ZM15.5 4.51408C15.4924 6.4406 13.9283 8 12 8C10.0717 8 8.50762 6.4406 8.50003 4.51408L8.5 4.52857C8.5 4.86517 8.54491 5.19098 8.62891 5.5H5L5 19.5H19V5.5H15.3711C15.4551 5.19098 15.5 4.86517 15.5 4.52857L15.5 4.51408ZM15.3551 3.5C14.9248 2.05426 13.5855 1 12 1C10.4145 1 9.07521 2.05426 8.64494 3.5H5C3.89543 3.5 3 4.39543 3 5.5V19.5C3 20.6046 3.89543 21.5 5 21.5H19C20.1046 21.5 21 20.6046 21 19.5V5.5C21 4.39543 20.1046 3.5 19 3.5H15.3551ZM7 11C7 10.4477 7.44772 10 8 10H16C16.5523 10 17 10.4477 17 11C17 11.5523 16.5523 12 16 12H8C7.44772 12 7 11.5523 7 11ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14H8Z"
            fill="currentColor"
        />
    </svg>
</template>
